"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useCallbackRef = require("use-callback-ref");
var _compoundComponents = require("@clds/compound-components");
var _DropdownMenu = require("../DropdownMenu.hooks");
var _DropdownMenuContext = require("../DropdownMenuContext");
var _useConnectedDropdownTrigger = require("./useConnectedDropdownTrigger");
var _useDropdownRegistry = require("./useDropdownRegistry");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useDropdownMenu = (props, state) => {
  var _props$focusOnClose;
  const triggerRef = (0, _react.useRef)(null);
  const menuRef = (0, _react.useRef)(null);
  const focusOnCloseWithDefault = (_props$focusOnClose = props.focusOnClose) !== null && _props$focusOnClose !== void 0 ? _props$focusOnClose : true;
  const {
    context,
    isClosable
  } = (0, _useDropdownRegistry.useDropdownRegistry)();
  (0, _DropdownMenu.useFocusManagement)(menuRef, triggerRef, state.isOpened, focusOnCloseWithDefault);
  const navigationRef = (0, _useCallbackRef.useMergeRefs)([menuRef, _DropdownMenu.useFocusOnMount]);
  const connectedTrigger = (0, _useConnectedDropdownTrigger.useConnectedDropdownTrigger)(props.trigger, triggerRef, state.isOpened);
  const connectedItems = /*#__PURE__*/_react.default.createElement(_DropdownMenuContext.DropdownMenuContextProvider, {
    value: context
  }, props.items);
  return {
    connectedTrigger,
    connectedItems,
    navigationRef,
    menuProps: {
      onSelect: id => state.select(id, id === _compoundComponents.unselect || isClosable(id)),
      focusedId: state.focusedId,
      onFocusedIdChange: state.setFocusedId,
      selectedId: state.selectedId
    },
    popoverProps: {
      visible: state.isOpened,
      onVisibleChange: state.setOpened
    }
  };
};
exports.useDropdownMenu = useDropdownMenu;
//# sourceMappingURL=useDropdownMenu.js.map